import {
  SupportSource,
  trackSupportClick,
  trackSupportPromptShown,
} from "@/lib/analytics";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import { Box, Button, Dialog, DialogContent, Typography } from "@mui/material";
import { useEffect, useRef } from "react";

interface SupportDialogProps {
  open: boolean;
  source: SupportSource;
  onClose: () => void;
}

export default function SupportDialog({ open, source, onClose }: SupportDialogProps) {
  const wasOpen = useRef(false);

  useEffect(() => {
    if (open && !wasOpen.current) trackSupportPromptShown(source);
    wasOpen.current = open;
  }, [open, source]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          background:
            "linear-gradient(180deg, rgba(13,27,42,0.98) 0%, rgba(10,20,32,0.99) 100%)",
          border: "1px solid rgba(79,195,247,0.12)",
          borderRadius: 3,
        },
      }}
    >
      <DialogContent sx={{ textAlign: "center", py: 4, px: 3 }}>
        <FavoriteBorderIcon
          sx={{
            fontSize: 40,
            color: "primary.main",
            opacity: 0.7,
            mb: 1.5,
          }}
        />
        <Typography
          sx={{
            fontSize: "1.1rem",
            fontWeight: 700,
            color: "text.primary",
            mb: 0.5,
          }}
        >
          We all hate ads.
        </Typography>
        <Typography
          sx={{
            fontSize: "0.8rem",
            color: "text.secondary",
            mb: 3,
            lineHeight: 1.6,
          }}
        >
          That&apos;s why we&apos;re here.
          <br />
          If you like what you see — buy us a beer or coffee to keep the cams running.
        </Typography>

        <Box sx={{ display: "flex", gap: 1.5, justifyContent: "center" }}>
          <Button
            onClick={onClose}
            size="small"
            sx={{
              color: "text.secondary",
              textTransform: "none",
              fontSize: "0.8rem",
            }}
          >
            Good luck!
          </Button>
          <Button
            component="a"
            href="https://www.buymeacoffee.com/howisthesurf"
            target="_blank"
            rel="noreferrer"
            variant="contained"
            size="small"
            onClick={() => {
              trackSupportClick("buy_me_a_coffee", source);
              onClose();
            }}
            sx={{
              textTransform: "none",
              fontWeight: 600,
              px: 2.5,
              fontSize: "0.8rem",
              borderRadius: 2,
            }}
          >
            Coffee
          </Button>
          <Button
            component="a"
            href="https://www.paypal.com/paypalme2/powdertothepeopletv"
            target="_blank"
            rel="noreferrer"
            variant="contained"
            size="small"
            onClick={() => {
              trackSupportClick("paypal", source);
              onClose();
            }}
            sx={{
              textTransform: "none",
              fontWeight: 600,
              px: 2.5,
              fontSize: "0.8rem",
              borderRadius: 2,
            }}
          >
            Beer
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
